import {Injectable} from '@angular/core';
import {BaseEndpointService} from '../base-endpoint-service';
import {Backend} from '@generated-backend-types';
import {ListItem} from "src/app/entities/list-item.entity";
import Publication = Backend.App.Resources.Dashboard.Administration.Publication;
import PublicationData = Backend.App.Data.Dashboard.Administration.PublicationData;

@Injectable({providedIn: 'root'})
export class PublicationService extends BaseEndpointService<Publication, PublicationData> {
  protected override endpoint = '/administration/publications';

  public override modelToMultiSelectItem(m: Publication): ListItem & { model: Publication; } {
    return {
      id: m.id,
      text: m.title,
      isDisabled: false,
      model: m,
    }
  }
}
